// US State abbreviations for dropdown menus
export const US_STATES = [
  { value: 'AL', label: 'AL - Alabama' },
  { value: 'AK', label: 'AK - Alaska' },
  { value: 'AZ', label: 'AZ - Arizona' },
  { value: 'AR', label: 'AR - Arkansas' },
  { value: 'CA', label: 'CA - California' },
  { value: 'CO', label: 'CO - Colorado' },
  { value: 'CT', label: 'CT - Connecticut' },
  { value: 'DE', label: 'DE - Delaware' },
  { value: 'FL', label: 'FL - Florida' },
  { value: 'GA', label: 'GA - Georgia' },
  { value: 'HI', label: 'HI - Hawaii' },
  { value: 'ID', label: 'ID - Idaho' },
  { value: 'IL', label: 'IL - Illinois' },
  { value: 'IN', label: 'IN - Indiana' },
  { value: 'IA', label: 'IA - Iowa' },
  { value: 'KS', label: 'KS - Kansas' },
  { value: 'KY', label: 'KY - Kentucky' },
  { value: 'LA', label: 'LA - Louisiana' },
  { value: 'ME', label: 'ME - Maine' },
  { value: 'MD', label: 'MD - Maryland' },
  { value: 'MA', label: 'MA - Massachusetts' },
  { value: 'MI', label: 'MI - Michigan' },
  { value: 'MN', label: 'MN - Minnesota' },
  { value: 'MS', label: 'MS - Mississippi' },
  { value: 'MO', label: 'MO - Missouri' },
  { value: 'MT', label: 'MT - Montana' },
  { value: 'NE', label: 'NE - Nebraska' },
  { value: 'NV', label: 'NV - Nevada' },
  { value: 'NH', label: 'NH - New Hampshire' },
  { value: 'NJ', label: 'NJ - New Jersey' },
  { value: 'NM', label: 'NM - New Mexico' },
  { value: 'NY', label: 'NY - New York' },
  { value: 'NC', label: 'NC - North Carolina' },
  { value: 'ND', label: 'ND - North Dakota' },
  { value: 'OH', label: 'OH - Ohio' },
  { value: 'OK', label: 'OK - Oklahoma' },
  { value: 'OR', label: 'OR - Oregon' },
  { value: 'PA', label: 'PA - Pennsylvania' },
  { value: 'RI', label: 'RI - Rhode Island' },
  { value: 'SC', label: 'SC - South Carolina' },
  { value: 'SD', label: 'SD - South Dakota' },
  { value: 'TN', label: 'TN - Tennessee' },
  { value: 'TX', label: 'TX - Texas' },
  { value: 'UT', label: 'UT - Utah' },
  { value: 'VT', label: 'VT - Vermont' },
  { value: 'VA', label: 'VA - Virginia' },
  { value: 'WA', label: 'WA - Washington' },
  { value: 'WV', label: 'WV - West Virginia' },
  { value: 'WI', label: 'WI - Wisconsin' },
  { value: 'WY', label: 'WY - Wyoming' },
  { value: 'DC', label: 'DC - District of Columbia' }
];

// World countries for dropdown menus
export const COUNTRIES = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, Democratic Republic of the' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: 'Côte d\'Ivoire' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czechia' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },

  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See (Vatican City State)' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran, Islamic Republic of' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: 'Korea, Democratic People\'s Republic of' },
  { value: 'KR', label: 'Korea, Republic of' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Lao People\'s Democratic Republic' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MK', label: 'Macedonia, the former Yugoslav Republic of' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia, Federated States of' },
  { value: 'MD', label: 'Moldova, Republic of' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },

  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine, State of' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },

  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan, Province of China' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania, United Republic of' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },

  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela, Bolivarian Republic of' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands, British' },

  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' }
];

// Florida Counties for dropdown menus
export const FLORIDA_COUNTIES = [
  'Alachua County',
  'Baker County',
  'Bay County',
  'Bradford County',
  'Brevard County',
  'Broward County',
  'Calhoun County',
  'Charlotte County',
  'Citrus County',
  'Clay County',
  'Collier County',
  'Columbia County',
  'DeSoto County',
  'Dixie County',
  'Duval County',
  'Escambia County',
  'Flagler County',
  'Franklin County',
  'Gadsden County',
  'Gilchrist County',
  'Glades County',
  'Gulf County',
  'Hamilton County',
  'Hardee County',
  'Hendry County',
  'Hernando County',
  'Highlands County',
  'Hillsborough County',
  'Holmes County',
  'Indian River County',
  'Jackson County',
  'Jefferson County',
  'Lafayette County',
  'Lake County',
  'Lee County',
  'Leon County',
  'Levy County',
  'Liberty County',
  'Madison County',
  'Manatee County',
  'Marion County',
  'Martin County',
  'Miami-Dade County',
  'Monroe County',
  'Nassau County',
  'Okaloosa County',
  'Okeechobee County',
  'Orange County',
  'Osceola County',
  'Palm Beach County',
  'Pasco County',
  'Pinellas County',
  'Polk County',
  'Putnam County',
  'St. Johns County',
  'St. Lucie County',
  'Santa Rosa County',
  'Sarasota County',
  'Seminole County',
  'Sumter County',
  'Suwannee County',
  'Taylor County',
  'Union County',
  'Volusia County',
  'Wakulla County',
  'Walton County',
  'Washington County'
];

// Florida Law Enforcement Agencies for dropdown menus
export const FLORIDA_LAW_ENFORCEMENT_AGENCIES = [
  // Police Departments
  'Alachua Police Department',
  'Altamonte Springs Police Department',
  'Altha Police Department',
  'Apalachicola Police Department',
  'Apopka Police Department',
  'Arcadia Police Department',
  'Astatula Police Department',
  'Atlantic Beach Police Department',
  'Atlantis Police Department',
  'Auburndale Police Department',
  'Aventura Police Department',
  'Bal Harbour Village Police Department',
  'Bartow Police Department',
  'Bay Harbor Islands Police Department',
  'Belleair Police Department',
  'Belleview Police Department',
  'Biscayne Park Police Department',
  'Blountstown Police Department',
  'Boca Raton Police Services Department',
  'Bonifay Police Department',
  'Bowling Green Police Department',
  'Boynton Beach Police Department',
  'Bradenton Beach Police Department',
  'Bradenton Police Department',
  'Bunnell Police Department',
  'Bushnell Department Of Public Safety',
  'Cape Coral Police Department',
  'Carrabelle Police Department',
  'Casselberry Police Department',
  'Cedar Key Police Department',
  'Chattahoochee Police Department',
  'Chiefland Police Department',
  'Chipley Police Department',
  'City Of Belle Isle Police Department',
  'Clearwater Police Department',
  'Clermont Police Department',
  'Clewiston Police Department',
  'Cocoa Beach Police Department',
  'Cocoa Police Department',
  'Coconut Creek Police Department',
  'Coral Gables Police Department',
  'Coral Springs Police Department',
  'Cottondale Police Department',
  'Crestview Police Department',
  'Cross City Police Department',
  'Dade City Police Department',
  'Davenport Police Department',
  'Davie Police Department',
  'Daytona Beach Police Department',
  'Daytona Beach Shores Public Safety Department',
  'Defuniak Springs Police Department',
  'Deland Police Department',
  'Delray Beach Police Department',
  'Doral Police Department',
  'Dunnellon Police Department',
  'Eatonville Police Department',
  'Edgewater Police Department',
  'Edgewood Police Department',
  'El Portal Police Department',
  'Eustis Police Department',
  'Fellsmere Police Department',
  'Fernandina Beach Police Department',
  'Flagler Beach Police Department',
  'Florida City Police Department',
  'Fort Lauderdale Police Department',
  'Fort Myers Police Department',
  'Fort Pierce Police Department',
  'Fort Walton Beach Police Department',
  'Fruitland Park Police Department',
  'Gainesville Police Department',
  'Golden Beach Police Department',
  'Graceville Police Department',
  'Green Cove Springs Police Department',
  'Gretna Police Department',
  'Groveland Police Department',
  'Gulf Breeze Police Department',
  'Gulf Stream Police Department',
  'Gulfport Police Department',
  'Haines City Police Department',
  'Hallandale Beach Police Department',
  'Havana Police Department',
  'Hialeah Gardens Police Department',
  'Hialeah Police Department',
  'High Springs Police Department',
  'Highland Beach Police Department',
  'Hillsboro Beach Police Department',
  'Holly Hill Police Department',
  'Hollywood Police Department',
  'Holmes Beach Police Department',
  'Homestead Police Department',
  'Howey-In-The-Hills Police Department',
  'Indialantic Police Department',
  'Indian Creek Village Public Safety Department',
  'Indian Harbour Beach Police Department',
  'Indian River Shores Public Safety Department',
  'Indian Shores Police Department',
  'Interlachen Police Department',
  'Jacksonville Beach Police Department',
  'Jasper Police Department',
  'Jennings Police Department',
  'Juno Beach Police Department',
  'Jupiter Inlet Colony Police Department',
  'Jupiter Island Public Safety Department',
  'Jupiter Police Department',
  'Kenneth City Police Department',
  'Key Biscayne Police Department',
  'Key Colony Beach Police Department',
  'Key West Police Department',
  'Kissimmee Police Department',
  'Lady Lake Police Department',
  'Lake Alfred Police Department',
  'Lake City Police Department',
  'Lake Clarke Shores Police Department',
  'Lake Hamilton Police Department',
  'Lake Helen Police Department',
  'Lake Mary Police Department',
  'Lake Placid Police Department',
  'Lake Wales Police Department',
  'Lakeland Police Department',
  'Lantana Police Department',
  'Largo Police Department',
  'Lauderhill Police Department',
  'Lawtey Police Department',
  'Leesburg Police Department',
  'Lighthouse Point Police Department',
  'Live Oak Police Department',
  'Longboat Key Police Department',
  'Longwood Police Department',
  'Lynn Haven Police Department',
  'Madison Police Department',
  'Maitland Police Department',
  'Manalapan Police Department',
  'Marco Island Police Department',
  'Margate Police Department',
  'Marianna Police Department',
  'Mascotte Police Department',
  'Medley Police Department',
  'Melbourne Beach Police Department',
  'Melbourne Police Department',
  'Miami Beach Police Department',
  'Miami Gardens Police Department',
  'Miami Police Department',
  'Miami Shores Police Department',
  'Miami Springs Police Department',
  'Miccosukee Police Department',
  'Midway Police Department',
  'Milton Police Department',
  'Miramar Police Department',
  'Monticello Police Department',
  'Mount Dora Police Department',
  'Naples Police Department',
  'Neptune Beach Police Department',
  'New Port Richey Police Department',
  'New Smyrna Beach Police Department',
  'Niceville Police Department',
  'North Bay Village Police Department',
  'North Miami Beach Police Department',
  'North Miami Police Department',
  'North Palm Beach Police Department',
  'North Port Police Department',
  'Oakland Police Department',
  'Ocala Police Department',
  'Ocean Ridge Police Department',
  'Ocoee Police Department',
  'Okeechobee Police Department',
  'Opa Locka Police Department',
  'Orange City Police Department',
  'Orange Park Police Department',
  'Orlando Police Department',
  'Ormond Beach Police Department',
  'Oviedo Police Department',
  'Palatka Police Department',
  'Palm Bay Police Department',
  'Palm Beach Gardens Police Department',
  'Palm Beach Police Department',
  'Palm Springs Public Safety Department',
  'Palmetto Police Department',
  'Panama City Beach Police Department',
  'Panama City Police Department',
  'Parker Police Department',
  'Pembroke Pines Police Department',
  'Pensacola Police Department',
  'Perry Police Department',
  'Pinecrest Police Department',
  'Pinellas Park Police Department',
  'Plant City Police Department',
  'Plantation Police Department',
  'Ponce Inlet Police Department',
  'Port Orange Police Department',
  'Port Richey Police Department',
  'Port St. Joe Police Department',
  'Port St. Lucie Police Department',
  'Punta Gorda Police Department',
  'Quincy Police Department',
  'Riviera Beach Police Department',
  'Rockledge Police Department',
  'Sanford Police Department',
  'Sanibel Police Department',
  'Sarasota Police Department',
  'Satellite Beach Police Department',
  'Sea Ranch Lakes Police Department',
  'Sebastian Police Department',
  'Sebring Police Department',
  'Seminole Police Department',
  'South Daytona Police Department',
  'South Miami Police Department',
  'South Palm Beach Police Department',
  'Springfield Police Department',
  'St. Augustine Police Department',
  'St. Cloud Police Department',
  'St. Pete Beach Police Department',
  'Starke Police Department',
  'Stuart Police Department',
  'Sunny Isles Beach Police Department',
  'Sunrise Police Department',
  'Surfside Police Department',
  'Sweetwater Police Department',
  'Tallahassee Police Department',
  'Tamarac Police Department',
  'Tampa Police Department',
  'Tarpon Springs Police Department',
  'Tavares Police Department',
  'Temple Terrace Police Department',
  'Tequesta Police Department',
  'Titusville Police Department',
  'Treasure Island Police Department',
  'Trenton Police Department',
  'Umatilla Police Department',
  'Valparaiso Police Department',
  'Venice Police Department',
  'Vero Beach Police Department',
  'Virginia Gardens Police Department',
  'Wauchula Police Department',
  'Webster Police Department',
  'West Melbourne Police Department',
  'West Miami Police Department',
  'West Palm Beach Police Department',
  'White Springs Police Department',
  'Wildwood Police Department',
  'Williston Police Department',
  'Wilton Manors Police Department',
  'Winter Garden Police Department',
  'Winter Haven Police Department',
  'Winter Park Police Department',
  'Winter Springs Police Department',
  'Zephyrhills Police Department',

  // Sheriff's Offices
  'Alachua County Sheriff\'s Office',
  'Baker County Sheriff\'s Office',
  'Bay County Sheriff\'s Office',
  'Bradford County Sheriff\'s Office',
  'Brevard County Sheriff\'s Office',
  'Broward County Sheriff\'s Office',
  'Calhoun County Sheriff\'s Office',
  'Charlotte County Sheriff\'s Office',
  'Citrus County Sheriff\'s Office',
  'Clay County Sheriff\'s Office',
  'Collier County Sheriff\'s Office',
  'Columbia County Sheriff\'s Office',
  'Desoto County Sheriff\'s Office',
  'Dixie County Sheriff\'s Office',
  'Escambia County Sheriff\'s Office',
  'Flagler County Sheriff\'s Office',
  'Franklin County Sheriff\'s Office',
  'Gadsden County Sheriff\'s Office',
  'Gilchrist County Sheriff\'s Office',
  'Glades County Sheriff\'s Office',
  'Gulf County Sheriff\'s Office',
  'Hamilton County Sheriff\'s Office',
  'Hardee County Sheriff\'s Office',
  'Hendry County Sheriff\'s Office',
  'Hernando County Sheriff\'s Office',
  'Highlands County Sheriff\'s Office',
  'Hillsborough County Sheriff\'s Office',
  'Holmes County Sheriff\'s Office',
  'Indian River County Sheriff\'s Office',
  'Jackson County Sheriff\'s Office',
  'Jacksonville Sheriff\'s Office',
  'Jefferson County Sheriff\'s Office',
  'Lafayette County Sheriff\'s Office',
  'Lake County Sheriff\'s Office',
  'Lee County Sheriff\'s Office',
  'Leon County Sheriff\'s Office',
  'Levy County Sheriff\'s Office',
  'Liberty County Sheriff\'s Office',
  'Madison County Sheriff\'s Office',
  'Manatee County Sheriff\'s Office',
  'Marion County Sheriff\'s Office',
  'Martin County Sheriff\'s Office',
  'Miami-Dade Sheriff\'s Office',
  'Monroe County Sheriff\'s Office',
  'Nassau County Sheriff\'s Office',
  'Okaloosa County Sheriff\'s Office',
  'Okeechobee County Sheriff\'s Office',
  'Orange County Sheriff\'s Office',
  'Osceola County Sheriff\'s Office',
  'Palm Beach County Sheriff\'s Office',
  'Pasco Sheriff\'s Office',
  'Pinellas County Sheriff\'s Office',
  'Polk County Sheriff\'s Office',
  'Putnam County Sheriff\'s Office',
  'Santa Rosa County Sheriff\'s Office',
  'Sarasota County Sheriff\'s Office',
  'Seminole County Sheriff\'s Office',
  'St. Johns County Sheriff\'s Office',
  'St. Lucie County Sheriff\'s Office',
  'Sumter County Sheriff\'s Office',
  'Suwannee County Sheriff\'s Office',
  'Taylor County Sheriff\'s Office',
  'Union County Sheriff\'s Office',
  'Volusia Sheriff\'s Office',
  'Wakulla County Sheriff\'s Office',
  'Walton County Sheriff\'s Office',
  'Washington County Sheriff\'s Office',

  // State Agencies
  'Department Of Agriculture And Consumer Services',
  'Department Of Environmental Protection',
  'Department Of Financial Services, Criminal Investigations Division',
  'Fifth District Court Of Appeal, Marshal\'s Office',
  'First District Court Of Appeal',
  'Florida Department Of Business Profess. Regulation-Ab&t',
  'Florida Department Of Highway Safety And Motor Vehicles',
  'Florida Department Of Law Enforcement',
  'Florida Department Of Lottery, Division Of Security',
  'Florida Fish And Wildlife Conservation Commission',
  'Florida Gaming Control Commission Law Enforcement',
  'Florida Supreme Court Marshal\'s Office',
  'Fourth District Court Of Appeals, Marshal\'s Office',
  'Office Of The Attorney General, Medicaid Fraud Control Unit',
  'Second District Court Of Appeal Marshal\'s Office',
  'Sixth District Court Of Appeal, Marshal\'s Office',
  'State Attorney\'s Office, Eighteenth Judicial Circuit',
  'State Attorney\'s Office, Eighth Judicial Circuit',
  'State Attorney\'s Office, Eleventh Judicial Circuit',
  'State Attorney\'s Office, Fifteenth Judicial Circuit',
  'State Attorney\'s Office, Fifth Judicial Circuit',
  'State Attorney\'s Office, First Judicial Circuit',
  'State Attorney\'s Office, Fourteenth Judicial Circuit',
  'State Attorney\'s Office, Fourth Judicial Circuit',
  'State Attorney\'s Office, Ninteenth Judicial Circuit',
  'State Attorney\'s Office, Ninth Judicial Circuit',
  'State Attorney\'s Office, Second Judicial Circuit',
  'State Attorney\'s Office, Seventeenth Judicial Circuit',
  'State Attorney\'s Office, Seventh Judicial Circuit',
  'State Attorney\'s Office, Sixteenth Judicial Circuit',
  'State Attorney\'s Office, Sixth Judicial Circuit',
  'State Attorney\'s Office, Tenth Judicial Circuit',
  'State Attorney\'s Office, Third Judicial Circuit',
  'State Attorney\'s Office, Thirteenth Judicial Circuit',
  'State Attorney\'s Office, Twelfth Judicial Circuit',
  'State Attorney\'s Office, Twentieth Judicial Circuit',
  'Third District Court Of Appeal, Marshal\'s Office'
];
